// extracted by mini-css-extract-plugin
module.exports = {"listItemNumber":"List_listItemNumber__1LqqU","item":"List_item__2sZoa"};